import CircleTick from '@service-victoria/component-library/components/Icons/CircleTick';
import styled from 'styled-components';

export const CircleTickIcon = styled(CircleTick)`
  width: 34px;
  height: 34px;
  margin-right: 12px;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 36px;
`;
